import { atom } from 'recoil';

export const modelsAtom = atom({
  key: 'modelsAtom',
  default: {
    loading: false,
    item: null,
    items: [],
    error: null
  },
});